import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    dialogPaper: {
      maxWidth: '65rem',
      maxHeight: '65rem',
      padding: theme.spacing(2, 1, 0),

      '& .MuiDialogTitle-root': {
        padding: theme.spacing(3, 3, 1.5),

        '& > .MuiTypography-h2': {
          fontWeight: 500,
          fontSize: '2.4rem',
        },
      },

      '& .MuiDialogContent-root': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),

        '& hr': {
          height: 2,
        },
      },

      '& .MuiDialogActions-root': {
        gap: theme.spacing(2.5),
        padding: theme.spacing(1, 3, 3),
        '& button': {
          width: '10rem',
          height: 'auto',
          margin: 0,
          padding: '1rem',
        },
      },
    },
    membersSection: {
      overflow: 'auto',
      minHeight: '20rem',
      display: 'flex',
      gridGap: '1rem',
      flexDirection: 'column',
      flex: 1,

      '& >h3': {
        fontSize: '1.6rem',
      },

      '& > .MuiBox-root': {
        '& > .MuiBox-root': {
          '& p:first-child': {
            fontWeight: 600,
          },
          '& p:last-child': {
            fontSize: '1.3rem',
            color: '#727970',
          },
        },
        '& > p': {
          color: '#727970',
          fontWeight: 600,
          fontSize: '1.4rem',
        },
      },
      '& button': {
        marginLeft: 'auto',
        height: '4.2rem',
        borderRadius: '.5rem',
        padding: '1.4rem',
        transition: 'all .2s',
        fontFamily: theme.typography.body1.fontFamily,
        fontWeight: 400,
        fontSize: '1.4rem',
        textTransform: 'initial',

        background: 'white',
        boxShadow: 'none',
        border: `.1rem solid ${theme.palette.secondary.light}`,

        '&:active': {
          transform: 'translateY(.1rem)',
          boxShadow: 'inherit',
        },
        '& > .MuiTouchRipple-root': {},
        color: theme.palette.secondary.main,
        '& .MuiToggleButton-label': {
          gap: '1rem',

          '& span:first-child': {
            fontSize: '1.8rem',
          },
        },

        '&.Mui-selected': {
          color: '#FFF',
          background: theme.palette.error.main,
          border: 'none',

          '&:hover': {
            background: theme.palette.error.main,
            filter: 'brightness(0.9)',
          },
        },
      },
    },
    loading: {
      flex: 1,
    },
  }),
)
